// Navigation constants and configuration
export const NAVBAR_CONFIG = {
  height: 58,
  backgroundColor: "#161C29",
} as const;

// Path to tab mapping for navigation
export const PATH_TO_TAB_MAP: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/fleets": "Fleet",
  "/fleet": "Fleet", // Support both paths for consistency
  "/units": "Unit",
} as const;

// Tab to path mapping for navigation
export const TAB_TO_PATH_MAP: Record<string, string> = {
  Dashboard: "/dashboard",
  Fleet: "/fleets",
  Unit: "/units",
} as const;

// Special pages that don't have an active tab
export const NO_TAB_PAGES = ["/alarm-detail"] as const;

// Pages that should show sidebar (Unit-related pages)
// Note: This is deprecated - TenantSidebar now uses URL params to determine visibility
export const SIDEBAR_PAGES = [
  "/units",
] as const;

export type TabName = keyof typeof TAB_TO_PATH_MAP;
export type PathName = keyof typeof PATH_TO_TAB_MAP;
